import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {
  GaTrackingEventCategory,
  GaTrackingEventLabel,
  GaTrackingEventName,
  GATrackingEventType
} from '../../constants';
import { SearchApplicationEventPayload } from '~shared/modules/application-event/models';

export class GaTrackingCategoryPageZeroResult implements GATrackingEvent {

  constructor(private payload: SearchApplicationEventPayload) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.CategoryPageZeroResult;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.CategoryPageZeroResult,
      label: this.getLabel(),
      category: GaTrackingEventCategory.Category,
      gtmCustom: {
        GA360_regularResults: this.payload.GA360_regularResults
      }
    };
  }

  private getLabel(): string {
    if (this.payload.expiredPromoTag) {
      return GaTrackingEventLabel.ExpiredPromoTag;
    }

    let label = this.payload.GA360_query ? this.payload.GA360_query.toString().toLowerCase() : '';

    if (this.payload.hasFilters) {
      label += ' - Filtered';
    }

    return label;
  }
}
